import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseServiceWithFilter } from './base.service';
import { ContactsFilter } from '@cl/shared/models/contacts/contacts-filter.model';
import { Contact } from '@cl/shared/models';

@Injectable({ providedIn: 'root' })
export class ContactsService extends BaseServiceWithFilter<Contact, ContactsFilter> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/contacts/');
    }

    toString(object: Contact): string {
        return !object ? '' : `${object.name || ''} ${object.surname || ''} ${object.contactEmail ? ['(', object.contactEmail, ')'].join('') : ''}`;
    }

    toLongString(object: Contact): string {
        const contactParts: string[] = [object.contactEmail, object.phone].filter((part: string): boolean => !!part);
        return !object ? '' : `${object.name || ''} ${object.surname || ''} ${contactParts.length > 0 ? `(${contactParts.join(', ')})` : ''}`;
    }
}
